import crypto from 'js-sha256';

export const generateHash = (content: unknown): string => {
  return crypto.sha256(content as any);
};
